<slb-navigation-framework
  [applicationLogo]="'assets/logos/delfi.png'"
  [applicationName]="'Galaxy'"
  [hasSidenav]="false"
  [notifications]="true"
  [pageTitle]="pageTitle"
  [secondaryNavigationItems]="secondaryLinks"
  [slbLogo]="'assets/logos/slb-white.png'"
>
  <slb-framework-toolbar>
    <ng-content *ngTemplateOutlet="toolbar"></ng-content>
  </slb-framework-toolbar>

  <slb-framework-sidenav>
    <ng-content *ngTemplateOutlet="sidenav"></ng-content>
  </slb-framework-sidenav>

  <slb-framework-content>
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </slb-framework-content>

  <slb-framework-page-header
    *ngIf="showHeader"
    [showBackButton]="false"
    [pageTitle]="pageTitle"
    [items]="secondaryLinks"
  >
    <!-- * * * The content below is only a placeholder and can be replaced * * * -->
    <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
  </slb-framework-page-header>
</slb-navigation-framework>

<ng-template #toolbar>
  <!-- * * * The content below is only a placeholder and can be replaced * * * -->
  <button slb-icon-button matTooltip="Help">
    <mat-icon svgIcon="help"></mat-icon>
  </button>
  <slb-notifications-panel
    [capacity]="notificationCount"
    [notificationItems]="notificationItems"
    [viewAllButtonVisible]="true"
  ></slb-notifications-panel>
  <slb-logout [userName]="'John Doe'"> </slb-logout>
  <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
</ng-template>

<ng-template #sidenav>
  <mat-nav-list class="app-sidenav">
    <!-- * * * The content below is only a placeholder and can be replaced * * * -->
    <a class="dls-navigation-item" matTooltip="Home" [matTooltipPosition]="'right'" [routerLink]="['home']">
      <mat-icon svgIcon="home"></mat-icon>
    </a>
    <a
      class="dls-navigation-item"
      matTooltip="Notifications"
      [matTooltipPosition]="'right'"
      [routerLink]="['notifications']"
    >
      <mat-icon svgIcon="layers"></mat-icon>
    </a>
    <span class="dls-navigation-item" matTooltip="More items" [matTooltipPosition]="'right'">
      <mat-icon svgIcon="more"></mat-icon>
    </span>
    <a class="dls-navigation-item" matTooltip="Themes" [matTooltipPosition]="'right'" [routerLink]="['themes']">
      <mat-icon svgIcon="color-picker"></mat-icon>
    </a>
    <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
  </mat-nav-list>
</ng-template>

<ng-template #content>
  <!-- * * * The content below is only a placeholder and can be replaced * * * Connects to app-routing -->
  <router-outlet></router-outlet>
  <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
</ng-template>
